import {Entity} from '../../core/commons/entity';
import {ValidatorFn, Validators} from '@angular/forms';


export class FormViewField implements Entity {
    id: number;
    placeholder: string;
    required: boolean;
    order: number;
    linebreak: boolean;
    alignment: string;
    newParagraph: boolean;
    blockWidth: number;
    blockAlignment: string;
    indentate: boolean;
    constructor(value: Object = {}) {
        Object.assign(this, value);
    }

    getValidators(): ValidatorFn[] {
        const validators: ValidatorFn[] = [];
        if (this.required) {
            validators.push(Validators.required)
        }
        return validators;
    }
}



// WEBPACK FOOTER //
// ./src/app/form-views/domain/form-view-field.ts